import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/misc/pageContext';

export function MiscContentDetailsErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for MiscContentDetails page (error: ${error})`);
}
